import React from 'react';
import _ from 'lodash';

import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { withStyles } from '@material-ui/core/styles';
import {
  Search as SearchIcon,
} from '@material-ui/icons';
import {
  WithStyles,
  createStyles,
  InputBase,
  InputAdornment,
} from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  searchIcon: {
    fill: '#BABABA',
    width: 28,
    height: 18,
    opacity: 0.5
  },
});

interface SearchFieldProps extends WithStyles<typeof styles> {
  allprops: object,
  adorment: any,
}

const SearchField = (props: SearchFieldProps) => {
  const {
    classes,
    adorment = 'start',
    ...allProps
  } = props;

  return (
    <>
      {
        _.isEqual(adorment, 'end') ? (
          <InputBase
            {...allProps}
            endAdornment={
              <InputAdornment position="end">
                <img className={classes.searchIcon} src="/assets/svg/myLibrary/search_icon.svg" alt="search"/>
              </InputAdornment>
            }
          />
        ) : (
            <InputBase
              {...allProps}
              startAdornment={
                <InputAdornment position="start">
                  <img className={classes.searchIcon} src="/assets/svg/myLibrary/search_icon.svg" alt="search"/>
                </InputAdornment>
              }
            />
          )
      }
    </>
  );

};


export default withStyles(styles)(SearchField);